import {
  PORTAL_HOME_ROUTE,
  PORTAL_LOGIN_LEGACY_ROUTE,
} from "@/lib/portal/portal-routes";

export function getLoginHashUrl(): string {
  const base = import.meta.env.BASE_URL.replace(/\/$/, "");
  return `${base}/#${PORTAL_HOME_ROUTE}`;
}

function hashPath(): string {
  const raw = window.location.hash.replace(/^#/, "");
  return raw.split("?")[0] || "/";
}

export function isOnLoginRoute(): boolean {
  const path = hashPath();
  return path === PORTAL_HOME_ROUTE || path === PORTAL_LOGIN_LEGACY_ROUTE;
}

export function redirectToLoginHashRoute(): void {
  if (isOnLoginRoute()) {
    return;
  }

  window.location.assign(getLoginHashUrl());
}
